import React from "react";
import { NavLink } from "react-router-dom";

class AboutCompany extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 bg-white">
          <div className="container">
            <div className="section-content ">
              <div className="m-service-containt text-black">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={require("./../../images/extfile/cranes-are-lifting-materials-at-a-busy-constructio-2024-10-16-23-07-58-utc.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-12">
                    <div className="service-about-right m-b30">
                      <h3 className="m-t0">
                        Heating, Ventillation & Air Conditioning(HVAC)
                      </h3>
                      <h4>A Comprehensive Approach to HVAC Excellence</h4>
                      <p>
                        At KUO ENTERPRISES LLP, we specialize in delivering
                        high-quality Heating, Ventilation, and Air Conditioning
                        (HVAC) solutions designed to create comfortable,
                        energy-efficient, and sustainable indoor environments.
                        Our expertise in HVAC engineering allows us to provide
                        comprehensive services tailored to meet the unique
                        requirements of each project.
                      </p>
                      <h4>Our HVAC Services:-</h4>
                      <p>
                        <b>Package Systems: </b>
                        Complete, customizable systems to meet your specific
                        building needs.
                      </p>
                      <p>
                        <b>Design, Consultancy &Planning:</b>
                        Expertise in HVAC and Building Management Controls to
                        ensure efficient and seamless operation.
                      </p>
                      <p>
                        <b>Advanced Systems:</b>
                        We offer ducted split systems, VRF & VRV systems, as
                        well as chiller and plant rooms equipped with cooling
                        tower packages.
                      </p>
                      <p>
                        <b>Innovative Technology:</b>
                        Featuring Vapor Absorption Machines and state-of-the-art
                        air-handling units for both exhaust and fresh air
                        systems.
                      </p>
                      <p>
                        <b>Energy Efficiency:</b>
                        Conducting CFD analysis andCO₂ balance assessments to
                        maintain optimal indoor air quality.
                      </p>
                      <p>
                        <b>Energy Audits and Retrofits:</b> Comprehensiveenergy
                        audits with retrofit solutions to enhance energy
                        performance and reduce operational costs.
                      </p>
                      <p>
                        <b>SystemMaintenance and Operations:</b>
                        Ongoing support through ourOperations & Maintenance
                        (O&M) services, ensuring long-lasting system
                        performance.
                      </p>
                      <h4>
                        Why Choose KUO ENTERPRISES LLP for HVAC Solutions?
                      </h4>
                      <p>
                        With a commitment to quality, safety, and
                        sustainability, we integrate the latest HVAC
                        technologies to improve energy efficiency and adhere to
                        industry standards. Our portfolio spans various sectors,
                        including commercial buildings, healthcare facilities,
                        and residential complexes. Through collaboration with
                        our clients, we transform their visions of comfortable,
                        efficient, and sustainable environments into reality.
                      </p>
                      <p>
                        Experience the benefits of innovative HVAC solutions
                        designed to stand the test of time with KUO ENTERPRISES
                        LLP.
                      </p>

                      <div className="call-for-quote-outer">
                        <div className="call-quote">
                          <span>Call For a Quote:</span>
                          <h4> +91 8921197287, 9437630763</h4>
                        </div>
                        <div className="call-estimate bg-dark">
                          <NavLink
                            to={"#"}
                            className="site-button-secondry btn-effect"
                          >
                            Online Estimate Form
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutCompany;
